// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10NC6","content":"styles_content__1Stsm","tableWrap":"styles_tableWrap__xreXp"};